import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { ModalsProvider } from 'core/modals/ModalsProvider';
import createStore from 'core/store/createStore';
import { RootLayout } from 'layouts/root-layout/RootLayout';

const store = createStore();

const TOAST_CONTAINER_AUTO_CLOSE_TIMEOUT = 2000;

export const App: React.FC = () => (
  <ReduxProvider store={store}>
    <BrowserRouter forceRefresh={false}>
      <ModalsProvider>
        <RootLayout />
      </ModalsProvider>
    </BrowserRouter>
    <ToastContainer
      autoClose={TOAST_CONTAINER_AUTO_CLOSE_TIMEOUT}
      hideProgressBar={false}
    />
  </ReduxProvider>
);
